import { Component } from '@angular/core';
import { ManagerInspectionListComponent } from './admin-list.component';

@Component({
  selector: 'manager-installation-list-table',
  templateUrl: './admin-installation-list.component.html',
  standalone: false
})
export class ManagerInstallationListComponent extends ManagerInspectionListComponent {}
